import React from 'react';
import './WhyChooseUs.css'
import Subtitle from '../components/Subtitle';
import Title from '../components/Title';
import Paragraph from '../components/Paragraph';
import IconCard from '../components/IconCard';

const WhyChooseUs = () => {
    return (<>
    <section className='section4'>
        <div className='text-container'>
        <Subtitle text='Why Choose Us' css3='subtitle'/>
        <Title text1='Proven Track Record of Success' css2='text2'/>
        <div className='line3'></div>
        <Paragraph text1='Our commitment to excellence is reflected in our results and the trust our clients place in us' css5='paragraph'/>
        </div>

        <IconCard />
    </section>
    </>);
}
 
export default WhyChooseUs;